import styled from "styled-components";

export const Wrapper = styled.div`
.tiles-details{
    .ant-collapse-item .ant-collapse-header {
        padding: 6px 0 !important;
    }
    .ant-collapse-content-box {
        padding-right: 0 !important;
    }
    .ant-collapse-header-text {
        font-weight: 500;
    }
}
`